import { logger } from '@amzn/atoz-shiftapp-metrics';
import i18n from 'i18next';
export var formattedCurrency = function (currency) {
    if (!currency || !currency.amount) {
        return null;
    }
    var amount = currency.amount, code = currency.code;
    try {
        var formatter = new Intl.NumberFormat(i18n.language, {
            style: 'currency',
            currency: code
        });
        return formatter.format(amount);
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    }
    catch (err) {
        logger.emitError('formattedCurrency received an invalid currencyCode', {
            error: new Error(err),
            context: { invalidCurrencyCode: code }
        });
        return null;
    }
};
